/**
 * Цветовые палитры для бейджей ролей (полная палитра)
 */
export const BADGE_PRESETS = [
  { name: 'Синий',      bg: '#eff6ff', text: '#1d4ed8', border: '#bfdbfe' },
  { name: 'Индиго',     bg: '#eef2ff', text: '#4338ca', border: '#c7d2fe' },
  { name: 'Фиолетовый', bg: '#f5f3ff', text: '#6d28d9', border: '#ddd6fe' },
  { name: 'Пурпурный',  bg: '#fdf4ff', text: '#a21caf', border: '#f0abfc' },
  { name: 'Розовый',    bg: '#fdf2f8', text: '#be185d', border: '#fbcfe8' },
  { name: 'Красный',    bg: '#fef2f2', text: '#b91c1c', border: '#fecaca' },
  { name: 'Оранжевый',  bg: '#fff7ed', text: '#c2410c', border: '#fed7aa' },
  { name: 'Янтарный',   bg: '#fffbeb', text: '#b45309', border: '#fde68a' },
  { name: 'Жёлтый',    bg: '#fefce8', text: '#a16207', border: '#fef08a' },
  { name: 'Лаймовый',  bg: '#f7fee7', text: '#4d7c0f', border: '#d9f99d' },
  { name: 'Изумрудный', bg: '#ecfdf5', text: '#047857', border: '#a7f3d0' },
  { name: 'Бирюзовый',  bg: '#f0fdfa', text: '#0f766e', border: '#99f6e4' },
  { name: 'Голубой',    bg: '#ecfeff', text: '#0e7490', border: '#a5f3fc' },
  { name: 'Небесный',   bg: '#f0f9ff', text: '#0369a1', border: '#bae6fd' },
  { name: 'Серый',      bg: '#f1f5f9', text: '#334155', border: '#cbd5e1' },
  { name: 'Тёмный',     bg: '#1e293b', text: '#f1f5f9', border: '#334155' }
];
